import { createAction } from "@reduxjs/toolkit";

export const clearAuthState = createAction("auth/clearState");

export const resetPasswordStatusAction = createAction<{
  resetPasswordSuccess: boolean;
}>("auth/clearResetPasswordStatus");

export const clearSuccessImageUpload = createAction("auth/clearSuccessUpload")